const TOOLS = [
  {
    icon: "ri-download-2-line",
    title: "下载管理器",
    desc: "负责多任务排队与断点续传，是批量下载和离线转存的核心。支持同时挂多个任务，网速波动也不会前功尽弃。",
    tags: ["批量", "断点续传", "多线程"],
    highlight: false,
  },
  {
    icon: "ri-cloud-off-line",
    title: "离线中转网盘",
    desc: "先把资源拉到云端空间再转本地，适合网络不稳或想长期留档的场景。配合客户端自动同步，全程近乎无人值守。",
    tags: ["离线", "云端", "自动同步"],
    highlight: true,
  },
  {
    icon: "ri-archive-2-line",
    title: "压缩与整理工具",
    desc: "负责解压、批量重命名与打压缩包，是打包下载后归档的关键。把杂乱的资源整理成清晰目录，查找效率翻倍。",
    tags: ["打包", "重命名", "归档"],
    highlight: false,
  },
];

export default function Tools() {
  return (
    <section id="tools" className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-secondary-600">
            <i className="ri-tools-fill"></i>
            工具推荐
          </span>
          <h2 className="font-display text-2xl md:text-4xl text-foreground-950 mt-3">
            选对工具，下载事半功倍
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            本子网站资源下载离不开好工具。这里按“下载 → 转存 → 归档”的完整链路，
            推荐三类核心工具，组合起来就能覆盖大多数需求。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {TOOLS.map((t) => (
            <article
              key={t.title}
              className={`relative rounded-2xl border p-6 md:p-7 transition-transform duration-300 hover:-translate-y-1.5 ${
                t.highlight
                  ? "bg-primary-500 text-background-50 border-primary-500"
                  : "bg-background-100 border-background-200"
              }`}
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-xl ${
                  t.highlight ? "bg-background-50 text-primary-600" : "bg-secondary-500 text-background-50"
                }`}
              >
                <i className={`${t.icon} text-xl`}></i>
              </span>
              <h3
                className={`font-display text-xl mt-5 ${t.highlight ? "text-background-50" : "text-foreground-950"}`}
              >
                {t.title}
              </h3>
              <p
                className={`mt-2.5 text-sm leading-relaxed ${
                  t.highlight ? "text-background-100/90" : "text-foreground-700"
                }`}
              >
                {t.desc}
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {t.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                      t.highlight ? "bg-background-50/20 text-background-50" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: "ri-speed-up-line", num: "3 种", label: "主流下载方式" },
            { icon: "ri-file-transfer-line", num: "4 步", label: "完整操作链路" },
            { icon: "ri-cloud-off-line", num: "7×24", label: "离线随时可下" },
            { icon: "ri-folder-shield-line", num: "100%", label: "本地永久留档" },
          ].map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-3 rounded-2xl bg-background-100 border border-background-200 p-4"
            >
              <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className={`${s.icon} text-lg`}></i>
              </span>
              <div>
                <p className="font-display text-lg text-foreground-950 leading-none">{s.num}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}